import {AfterViewInit, Component, ElementRef, Inject, Input, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PasoWizard} from "../../../../interface/wizard-informacion.types";
import {GoogleMap} from "@angular/google-maps";
import {EvkSeccionModel} from "../../../../../expediente/models/evk-seccion.model";
import {takeUntil} from "rxjs/operators";
import {DatosSeccionWizardEventsService} from "../../../../services/datos-seccion-wizard-events.service";
import {WizardEventsService} from "../../../../services/wizard-events.service";
import {Subject} from "rxjs";
import {ButtonControlService} from "../../../../services/button-control.service";
import {WIZARD_DATA} from "../../../../tokens/tokens";


@Component({
    selector: 'evomatik-google-maps',
    templateUrl: './evomatik-google-maps.component.html',
    styleUrls: ['./evomatik-google-maps.component.css']
})
export class EvomatikGoogleMapsComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input()
    config: PasoWizard;

    @ViewChild('searchPlace')
    public searchElementRef!: ElementRef;

    @ViewChild(GoogleMap)
    public map!: GoogleMap;

    center!: google.maps.LatLngLiteral;
    options: google.maps.MapOptions = {
        center: {lat: 28.648457, lng: -106.065249},
        zoom: 10
    };

    markerOptions: google.maps.MarkerOptions = {icon: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless.png', draggable: true};
    markers: { id: number; lat: number; lng: number }[] = [
        {id: 1, lat: 48.85952222328431, lng: 2.3347153257887454}
    ];

    latitude!: any;
    longitude!: any;

    @Input()
    paso: PasoWizard;

    private _unsubscribeAll: Subject<any>;

    constructor(
                private ngZone: NgZone,
                public datosSeccionWizard: DatosSeccionWizardEventsService,
                private wizardEventsService: WizardEventsService,
                private buttonControlService: ButtonControlService) {
        this._unsubscribeAll = new Subject();

    }

    ngOnInit(): void {
        navigator.geolocation.getCurrentPosition((position) => {
            this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };
        });

        if (this.paso.inData['lat'] && this.paso.inData['lng']) {
            this.latitude = this.paso.inData['lat'];
            this.longitude = this.paso.inData['lng'];
            this.center = {
                lat: this.latitude,
                lng: this.longitude,
            };
            this.markers.push({id: 1, lat: this.latitude, lng: this.longitude});
        }
    }

    ngAfterViewInit(): void {
        let autocomplete = new google.maps.places.Autocomplete(
            this.searchElementRef.nativeElement
        );

        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
            this.searchElementRef.nativeElement
        );

        autocomplete.addListener('place_changed', () => {
            this.ngZone.run(() => {
                this.markers = [];
                //Obtiene el lugar
                let place: google.maps.places.PlaceResult = autocomplete.getPlace();

                //Verifica el resultado
                if (place.geometry === undefined || place.geometry === null) {
                    return;
                }

                //Guarda latitude, longitude y crea el marker
                this.latitude = place.geometry.location?.lat();
                this.longitude = place.geometry.location?.lng();
                this.center = {
                    lat: this.latitude,
                    lng: this.longitude,
                };
                this.markers.push({id: 1, lat: this.latitude, lng: this.longitude});
                this.onSelectionChange(this.center);
                this.validarInformacion();
            });
        });
    }

    onSelectionChange(data: any, save?: boolean) {
        if (data) {
            const response: EvkSeccionModel = {
                origen: this.config.nombre,
                propiedades: {
                    lat: data.lat ? data.lat : data.latitud,
                    lng: data.lng ? data.lng : data.longitud
                }
            }
            if (save) {
                this.datosSeccionWizard.onDoneSave.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                    this.wizardEventsService.save();
                })
            }
            this.datosSeccionWizard.doneSave(response);
        }
    }

    validarInformacion() {
        this.buttonControlService.cambiarBotonSiguiente(true);
        if (this.paso.inData && this.paso.inData[this.config.nombre] !== undefined) {
            this.buttonControlService.cambiarBotonSiguiente(true);
        } else {
            this.buttonControlService.cambiarBotonSiguiente(true);
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._unsubscribeAll.unsubscribe();
    }
}
